import ActionCableManager from '@shared/infra/protocols/websocket/ActionCableManager';
import SocketManager from '@shared/data/usecases/SocketManager';

const socketManager = new SocketManager(new ActionCableManager());

export default socketManager;
